import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { Box, Slider, Typography } from "@mui/material";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

PDFViewer.propTypes = {
  document: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default function PDFViewer(props) {
  const { document } = props;
  const [numPages, setNumPages] = useState();
  const [scaleValue, setScaleValue] = useState(1.0);

  const handleChange = (event, newValue) => {
    setScaleValue(newValue);
  };

  const onDocumentLoadSuccess = (pdf) => {
    setNumPages(pdf.numPages); // Anpassung hier!
  };

  return (
    <Fragment>
      <Box
        sx={{
          position: "absolute",
          bottom: "10px",
          left: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          zIndex: 999,
        }}
      >
        <Typography id="slider-label" gutterBottom>
          Zoom: {Math.round(scaleValue * 100) + "%"}
        </Typography>
        <Slider
          value={scaleValue}
          min={0.5}
          max={2.0}
          step={0.01}
          onChange={handleChange}
          aria-labelledby="slider-label"
        />
      </Box>
      <Document file={document} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
          <Box
            sx={{
              width: scaleValue * 600.0 + 10 + "px",
              margin: "20px",
              padding: "5px",
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: "#E6E6E6",
              borderRadius: "4px",
            }}
            key={`page_${index + 1}`}
          >
            <Page width={scaleValue * 600.0} pageNumber={index + 1} />
          </Box>
        ))}
      </Document>
    </Fragment>
  );
}
